/**
 * SafeCurves data loaders — wired into `safecurvesConfig.loaders`. The summary
 * `metadata` table sets the app-wide unit systems and jurisdiction as a side effect.
 */

import { loadSummaryTables, loadSystemLayers } from '#lib/common/loaders.js';
import { jurisdictionStore } from '#lib/stores/jurisdictionStore.svelte.js';
import { unitSystemStore } from '#lib/stores/unitSystemStore.svelte.js';
import { EProduct, ESafeCurvesModule, type ISafeCurvesSummaryData } from './interfaces';
import { SC_DATASET, buildSystemLayers as buildSCSystemLayers } from './layers';
import { CRASHES_DATASET, withCrashes } from '#lib/apps/safesystem/context/layers.js';

export const loadSystem = (apiKey: string) =>
	loadSystemLayers(apiKey, [SC_DATASET, CRASHES_DATASET], withCrashes(buildSCSystemLayers));

export const loadSummary = async (apiKey: string): Promise<ISafeCurvesSummaryData> =>
	(await loadSummaryTables(
		apiKey,
		EProduct.SafeCurves,
		SC_DATASET,
		[ESafeCurvesModule.Identify, ESafeCurvesModule.Prioritize, ESafeCurvesModule.Interventions],
		0,
		(row) => {
			unitSystemStore.setFromMetadata(row);
			jurisdictionStore.setFromMetadata(row);
		}
	)) as unknown as ISafeCurvesSummaryData;
